import { Component, OnInit, Input } from '@angular/core';
import { ProfileSurveyObservationService } from '../../service/profile-survey-observation/profile-survey-observation.service';
import { ProfileSurveyObservation } from '../../class/profile-survey-observation';
import { Message, ConfirmationService, LazyLoadEvent, CalendarModule, ToggleButtonModule } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { ProfileSurvey } from '../../class/profile-survey';

@Component({
  selector: 'app-profile-survey-observations',
  templateUrl: './profile-survey-observations.component.html',
  styleUrls: ['./profile-survey-observations.component.scss']
})
export class ProfileSurveyObservationsComponent implements OnInit {

    @Input() profileSurvey: ProfileSurvey;
    public promiseForm: Promise<any>;

    public msgs: Message[] = [];
    public profileSurveyObservation: ProfileSurveyObservation[];
    public selectProfileSurveyObservation: ProfileSurveyObservation;
    public profileSurveyId: Number = 0;
    public modNew = false;
    public modView = false;
    public openProfileSurveyObservation = false;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;

    constructor(
        public profileSurveyService: ProfileSurveyObservationService,
        public confirmationService: ConfirmationService,
        public translate: TranslateService) { }

    ngOnInit() {
        this.page = 1;
        this.per_page = 10;
        
    }

    public loadProfileSurveyObservationsLazy(event: LazyLoadEvent) {
        this.page = (event.first / this.per_page) + 1;
        
        if (event.sortOrder === -1) {
            this.sort =  '-' + event.sortField;
        } else {
            this.sort =  event.sortField;
        }
        if (this.profileSurvey) {
            this.getProfileSurveyObservationsByProfileSurvey(this.profileSurvey.id, event.globalFilter);
        } else {
            this.getProfileSurveyObservations(event.globalFilter);
        }
    }

    public getProfileSurveyObservations(query?: string) {
        this.profileSurveyService.getProfileSurveyObservation(this.page, this.per_page, this.sort, query).toPromise().then(
            response => {
                this.profileSurveyObservation = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public getProfileSurveyObservationsByProfileSurvey(id: number, query?: string) {
        this.profileSurveyService.getProfileSurveyObservationByProfileSurvey(id,
            this.page, this.per_page, this.sort, query).toPromise().then(
            response => {
                this.profileSurveyObservation = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public newProfileSurveyObservation() {
        this.modNew = !this.modNew;
        this.selectProfileSurveyObservation = null;
    }

    public savedProfileSurveyObservation(res) {
        this.msgs = [];
        this.msgs.push(res);
        this.selectProfileSurveyObservation = null;
        this.modNew = false;
        // this.getProfileSurveyObservations();
    }

    public cancelProfileSurveyObservation (res) {
        this.selectProfileSurveyObservation = null;
        this.modNew = false;
        this.modView = false;
        // this.getProfileSurveyObservations();
    }

    public edit(profileSurvey: ProfileSurveyObservation) {
        this.modNew = true;
        this.selectProfileSurveyObservation = profileSurvey;
        // this.getProfileSurveyObservations();
    }

    public view(profileSurvey: ProfileSurveyObservation) {
        this.openProfileSurveyObservation = true;
        this.selectProfileSurveyObservation = profileSurvey;
        this.profileSurveyId = profileSurvey.id;
        this.modView = true;
    }

    public deleteDialog(profileSurvey: ProfileSurveyObservation) {
        let message;
        this.translate.get('Do you want to delete?').subscribe((res: string) => {
            message = res;
        });

        let header;
        this.translate.get('Delete Confirmation').subscribe((res: string) => {
            header = res;
        });

        this.confirmationService.confirm({
            message: message,
            header: header,
            icon: 'fa fa-trash',
            accept: () => {
                this.delete(profileSurvey);
            }
        });
    }

    public delete(profileSurvey: ProfileSurveyObservation) {
        this.profileSurveyService.deleteProfileSurveyObservation(profileSurvey.id).toPromise().then(
            response => {
                this.msgs = [];
                this.msgs.push( { severity: 'success', summary: 'deleted' } );
                // if (this.profileSurvey) {
                //     this.getProfileSurveyObservationsByProfileSurvey(this.profileSurvey.id);
                // } else {
                //     this.getProfileSurveyObservations();
                // }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public activeProfileSurveyObservation(profileSurvey: ProfileSurveyObservation) {
        this.putProfileSurveyObservation(profileSurvey);
    }

    public putProfileSurveyObservation(values: ProfileSurveyObservation) {
        const param = {
            'activated': values.activated
        };
        if (values) {
            const promise = this.profileSurveyService.updateProfileSurveyObservation(values.id, param);
            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.msgs = [];
                        this.msgs.push( { severity: 'success', summary: res  } );
                    });
                },
                error => {
                    this.msgs.push( { severity: 'error', summary: 'Error' } );
                }
            );
        }
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/profile-survey-observations/profile-survey-observations.component.ts